<template>
    <div class="bg-white m-0">
        <!-- Your existing footer and other content -->
    
        <!-- Chat Section -->
        <div class="chat-container" v-show="isChatVisible">
            <div class="chat-header">
                <h3 class="custom-16px-500 text-left p-2">Messages</h3>
            </div>
            <div class="messages p-2">
                <div v-for="(msg, index) in filteredMessages" :key="index" :class="['message', msg.isUser ? 'user-message' : 'bot-message']">
                    <strong v-if="!msg.isUser"></strong> {{ msg.text }}
                </div>
                <!-- If user hasn't entered name yet, show input to ask for name -->
                <div v-if="!userKey" class="name-input">
    
                    <div style="display: flex; align-items: center; gap: 10px">
                        <CInput v-model="userFirstName" type="text" placeholder="First name" @keydown.enter="setUserName" />
                        <CInput v-model="userLastName" type="text" placeholder="Last name" @keydown.enter="setUserName" />
                        <img src="../assets/img/send.png" width="30px" height="30px" class="send-icon" @click="setUserName" style="cursor: pointer;" />
                    </div>
                </div>
            </div>
    
            <!-- Message input form -->
            <form @submit.prevent="sendMessage" class="message-form" v-if="userKey">
                <input type="text" v-model="userMessage" placeholder="Send your message" required />
                <img src="../assets/img/send.png" width="30px" height="30px" class="send-icon" @click="sendMessage" />
            </form>
        </div>
    
        <!-- Chat Icon -->
        <div class="chat-icon" @click="toggleChatVisibility">
            <img src="../assets/img/toggle-chat.png" alt="Chat Icon" />
        </div>
    </div>
</template>
 
 
<script>
import axios from "axios";

export default {
    data() {
        return {
            botToken: "7816967731:AAHh11dwPtvOe_2Dt26fi0djUYCFL5xd6oY", // Your bot token
            chatId: 89341897, // Chat ID to be set dynamically
            userKey: "", // User key based on name
            userFirstName: "",
            userLastName: "",
            userMessage: "",
            messages: [],
            lastUpdateId: null,
            isChatVisible: false,
        };
    },
    computed: {
        filteredMessages() {
            return this.messages.filter((msg) => msg.userKey === this.userKey);
        },
    },
    mounted() {
        axios
            .post(`https://api.telegram.org/bot${this.botToken}/deleteWebhook`)
            .then(() => {
                console.log("Webhook deleted, starting to poll for messages.");
            })
            .catch((error) => {
                console.error("Error deleting webhook:", error);
            });
    },
    methods: {
        // Method to automatically send the bot's first name request when the chat is opened
        askForName() {
            if (!this.userKey) {
                this.messages.push({
                    text: "Please enter your first name and last name.",
                    isUser: false,
                    senderName: "Bot",
                });
            }
        },

        // Handle sending user messages
        async sendMessage() {
            const message = this.userMessage.trim();
            if (!message) return;

            const messageTextWithName = `${this.userKey}: ${message}`;

            try {
                const url = `https://api.telegram.org/bot${this.botToken}/sendMessage`;
                const payload = {
                    chat_id: this.chatId,
                    text: messageTextWithName,
                };

                const response = await axios.post(url, payload);
                if (response.data.ok) {
                    this.messages.push({
                        text: message,
                        isUser: true,
                        userKey: this.userKey,
                    });
                    this.userMessage = "";
                } else {
                    console.error("Error sending message:", response.data.description);
                }
            } catch (error) {
                console.error("Error sending message:", error);
            }
        },

        // Fetch new messages
        async fetchMessages() {
            try {
                const url = `https://api.telegram.org/bot${this.botToken}/getUpdates`;
                const params = this.lastUpdateId ? { offset: this.lastUpdateId + 1 } : {};
                const response = await axios.post(url, params);
                const updates = response.data.result;

                updates.forEach((update) => {
                    if (update.message) {
                        const chatId = update.message.chat.id;
                        const text = update.message.text || "";
                        const senderFirstName = update.message.from.first_name || "";
                        const senderLastName = update.message.from.last_name || "";
                        const senderName = `${senderFirstName} ${senderLastName}`.trim();
                        const userKey = `${senderFirstName}_${senderLastName}`;

                        if (!this.chatId) this.chatId = chatId; // Assign chat ID dynamically

                        if (update.message.reply_to_message) {
                            const repliedText = update.message.reply_to_message.text || "";
                            const repliedUserKey = repliedText.split(":")[0];
                            if (repliedUserKey === this.userKey) {
                                this.messages.push({
                                    text: `${senderName}: ${text}`,
                                    isUser: false,
                                    userKey: repliedUserKey,
                                });
                            }
                        } else {
                            this.messages.push({
                                text,
                                isUser: senderName === this.userKey,
                                userKey,
                            });
                        }
                    }
                    this.lastUpdateId = update.update_id;
                });
            } catch (error) {
                console.error("Error fetching messages:", error);
            }
        },

        // Toggle the visibility of the chat
        toggleChatVisibility() {
            this.isChatVisible = !this.isChatVisible;
            if (this.isChatVisible) {
                this.askForName(); // Ask for the name when chat opens
                this.fetchMessages(); // Fetch initial messages
                this.fetchInterval = setInterval(this.fetchMessages, 3000); // Poll every 3 seconds
            } else {
                clearInterval(this.fetchInterval);
            }
        },

        // Set the user name and send a welcome message
        setUserName() {
            if (this.userFirstName && this.userLastName) {
                this.userKey = `${this.userFirstName}_${this.userLastName}`;
                this.messages.push({
                    text: `Hello, ${this.userFirstName}! How can I help you today?`,
                    isUser: false,
                    userKey: this.userKey,
                });
                this.userFirstName = "";
                this.userLastName = "";
            }
        },
    },
};
</script>

<style>
.pointer:hover {
    cursor: pointer;
    text-decoration: underline;
}

.chat-container {
    display: flex;
    flex-direction: column;
    position: fixed;
    bottom: 120px;
    right: 20px;
    width: 300px;
    height: 400px;
    border-radius: 20px;
    background-color: #f9f9f9;
    border: 1px solid #ddd;
    z-index: 1000;
}

.chat-header {
    color: #171717;
    text-align: left;
    font-size: 12px;
    background: #fff;
    border-top-right-radius: 20px;
    border-top-left-radius: 20px;
    padding: 5px;
    position: sticky;
    top: 0;
    z-index: 2;
    background-color: white;
}

.messages {
    flex-grow: 1;
    overflow-y: auto;
    margin-bottom: 10px;
    padding: 10px;
    display: flex;
    flex-direction: column;
    gap: 10px;
    max-height: 280px;
    scroll-behavior: smooth;
}

.message {
    max-width: 60%;
    padding: 10px;
    border-radius: 10px;
    word-wrap: break-word;
    display: inline-block;
}

.user-message {
    align-self: flex-start;
    border-radius: 20px;
    background: var(--surface-surface-tertiary, #F5F5F5);
    padding: 10px;
    color: #171717;
}

.bot-message {
    align-self: flex-end;
    border-radius: 20px;
    background: #928AFD;
    padding: 10px;
    color: #fff;
}

.message-form {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px;
    background: #fff;
    border-bottom-right-radius: 20px;
    border-bottom-left-radius: 20px;
}

input {
    flex-grow: 1;
    padding: 10px;
    font-size: 16px;
    border: 1px solid var(--Grayscale-200, #E5E5E5);
    border-radius: 25px;
    height: 40px;
}

.send-icon {
    cursor: pointer;
}

.chat-icon {
    position: fixed;
    bottom: 20px;
    right: 20px;
    cursor: pointer;
}

.chat-icon img {
    width: 100px;
    height: 100px;
    border-radius: 50%;
}

.name-input input {
    margin-bottom: 10px;
    padding: 5px;
}

.name-input button {
    padding: 5px;
    background-color: #4caf50;
    color: white;
    border: none;
    cursor: pointer;
    border-radius: 5px;
}
</style>